module.exports = __webpack_public_path__ + "img/FSA_pass.660e149f.jpeg";